import React, { useEffect } from 'react'
import { EditorTab, InvalidReason } from 'utils/cstore-legacy-mapping'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface InvalidTabsPopupProps {
  invalidReasons: InvalidReason[]
  onClose: () => void
  autoHideDuration?: number
}

export const InvalidTabsPopup: React.FC<InvalidTabsPopupProps> = ({
  invalidReasons,
  onClose,
  autoHideDuration = 5000
}) => {
  useEffect(() => {
    if (invalidReasons.length === 0) return

    const timer = setTimeout(() => {
      onClose()
    }, autoHideDuration)

    return () => clearTimeout(timer)
  }, [invalidReasons, autoHideDuration, onClose])

  if (!invalidReasons.length) return null

  // Group reasons by tab
  const reasonsByTab = invalidReasons.reduce(
    (acc, reason) => {
      const tab = reason.tab
      if (!acc[tab]) acc[tab] = []
      acc[tab].push(String(reason.reason))
      return acc
    },
    {} as Record<number, string[]>
  )

  return (
    <div style={popupContainerStyle}>
      <div style={popupHeaderStyle}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FontAwesomeIcon icon={faTriangleExclamation} color="#FF4136" /> {/* error icon */}
          Invalid Tabs Detected
        </span>
        <button style={closeButtonStyle} onClick={onClose}>
          ✕
        </button>
      </div>

      <ul style={popupListStyle}>
        {Object.entries(reasonsByTab).map(([tab, reasons]) => (
          <li key={tab} style={tabGroupStyle}>
            <strong style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              {EditorTab[Number(tab)]}
            </strong>

            <ul style={reasonListStyle}>
              {reasons.map((r, i) => (
                <li key={i}> {r}</li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  )
}

const popupContainerStyle: React.CSSProperties = {
  position: 'fixed',
  top: '50%', // center vertically
  left: '50%', // center horizontally
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#222',
  color: '#fff',
  padding: '16px 24px',
  borderRadius: 8,
  boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
  minWidth: 320,
  maxHeight: '300px',
  overflowY: 'auto',
  zIndex: 999
}

const popupHeaderStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 10,
  fontWeight: 'bold'
}

const popupListStyle: React.CSSProperties = {
  listStyle: 'none',
  padding: 0,
  margin: 0
}

const tabGroupStyle: React.CSSProperties = {
  marginBottom: 10
}

const reasonListStyle: React.CSSProperties = {
  marginTop: 4,
  paddingLeft: 16
}

const closeButtonStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#fff',
  fontSize: 16,
  cursor: 'pointer'
}
